import React from 'react'
import { formFieldsValue } from '../../../FormReducer/action'
import actionTarget from '../../../Redux/actionTarget'
import View from './view'

export class Radio extends React.Component {

    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }

    onChange(evt) {
        const {
            name,
            dispatch,
            storeTarget,
            readOnly
        } = this.props
        !readOnly && dispatch(actionTarget(formFieldsValue({ [name]: evt.target.value }), storeTarget))
    }

    render() {
        return (
            <View {...this.props}
                onChange={this.onChange}
            />
        )
    }
}
